<template>
    <baby-status-face
      :initialValue="state"
      :student="studentName"
      :title="title"
      @updatedElement="propagateChange"
      ref="element" />
</template>
<script>
import BabyStatusFace from './BabyStatusFace.vue'
import FuitOrYogurt from './FuitOrYogurt.vue'

export default {
  components: { BabyStatusFace, FuitOrYogurt },
  created: function () {
    if (this.$attrs.student) this.state = this.$attrs.student.dessertValue
  },
  props: {
    title: {
      type: String,
      default: () => 'Postre'
    },
    studentName: String
  },
  data: () => ({
    enabled: false,
    byDefault: 'mitad',
    state: ''
  }),
  methods: {
    setValue: function (value) {
      this.state = value
      this.$refs.element.setValue(value)
    },
    setEnable: function (value) {
      this.enabled = value
      this.$refs.element.setEnable(value)
      this.enabled ? this.setValue(this.byDefault) : this.setValue('ausente')
    },
    propagateChange: function (item) {
      this.$emit('updatedElement',
        { dessertValue: item.value }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/diaryElements/DessertValue.vue